import { createContext } from 'react'

export const UserLanguage = createContext(null)
